// extracted by css-extract-rspack-plugin
export default {"list":"N8saY48___list"};